export const plumbingContent = [
  {
    heroTitle: "Fast & Responsive Plumbing Experts",
    heroImg: "",
    altText: "",
  },
  {
    introTitle: "Providing Plumbing Services To Over 8000 Homes",
    introText: `Plumbing issues can be a real pain, so we respond as quickly as possible and endeavor to get the problem fixed efficiently and with minimal fuss.`,
  },
  {
    contLeftTitle: "Residential Plumbing Experts",
    contLeftText: `Whether you're carrying out home improvements to your existing plumbing, or whether it’s an urgent problem, AquaHeat is here to help you 24/7. `,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643102397/AquaHeat/new%20images/home1_dhhbnu.webp`,
  },
  {
    contRightTitle: "We Work Fast & Fix Problems",
    contRightText: `Through experience, we provide a streamlined and efficient service to ensure your plumbing problems are solved quickly. `,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643103740/AquaHeat/new%20images/plumbing-sq_b3m6is.webp`,
  },
  {
    callToActionTitle: "For Plumbing Call On 0113 467 0278",
    callToActionSubTitle: "Servicing Over 8000 homes and businesses",
    callToActionText: `We have a trained team of Gas Safe registered engineers and
              plumbers with a wide range of plumbing experience. Our plumbers
              are available for 24/7 call outs or for regular boiler maintenance
              work or new boiler installations.`,
  },
];
